var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKodaCoachMgmt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84198 12.9268C11.531 12.9268 14.684 13.4857 14.684 15.7188C14.684 17.9518 11.552 18.5268 7.84198 18.5268C4.15198 18.5268 1 17.9728 1 15.7388C1 13.5048 4.13098 12.9268 7.84198 12.9268Z",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8418 9.73996C6.68416 9.73585 5.57544 9.27257 4.75904 8.45181C3.94264 7.63105 3.48526 6.5199 3.48731 5.36224C3.48936 4.20459 3.95072 3.09505 4.77003 2.27719C5.58934 1.45933 6.69965 1 7.85731 1C9.01496 1 10.1253 1.45933 10.9446 2.27719C11.764 3.09505 12.2252 4.20459 12.2273 5.36224C12.2294 6.5199 11.772 7.63105 10.9556 8.45181C10.1392 9.27257 9.03046 9.73585 7.87281 9.73996H7.8418Z",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7329 8.60196C15.5101 8.48777 16.2212 8.10006 16.7381 7.50854C17.255 6.91703 17.544 6.16052 17.553 5.375C17.5621 4.58948 17.2906 3.82649 16.7874 3.22324C16.2842 2.61998 15.5823 2.21603 14.8079 2.08398",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8447 12.4521C18.3957 12.6831 19.4788 13.2271 19.4788 14.3521C19.4788 15.1231 18.9688 15.6232 18.1448 15.9362",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKodaCoachMgmt);
export default __webpack_public_path__ + "static/media/koda-coach-mgmt.348b8f563a06fb02ab2bb4167dc3c5db.svg";
export { ForwardRef as ReactComponent };